module.exports = __webpack_public_path__ + "img/swiper_05.87eb1c91.jpg";